import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';
export const ALERT_POST_SAVED: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'custom.post_saved',
    translate: true,
  },
  time: 2000,
};
